(() => {
  if (window.wwHomepageProductRailsReady) return;
  window.wwHomepageProductRailsReady = true;

  const selector = '[data-homepage-product-rail]';

  const updateRail = (rail) => {
    const isOverflowing = rail.scrollWidth > rail.clientWidth + 1;
    const scrollbar = rail.parentElement.querySelector('[data-homepage-product-scrollbar]');
    const thumb = scrollbar?.querySelector('[data-homepage-product-scrollbar-thumb]');

    rail.classList.toggle('is-overflowing', isOverflowing);
    rail.classList.add('is-overflow-ready');

    if (!scrollbar || !thumb) return;

    scrollbar.hidden = !isOverflowing;
    if (!isOverflowing) return;

    const trackWidth = scrollbar.clientWidth;
    const thumbWidth = Math.max(48, trackWidth * (rail.clientWidth / rail.scrollWidth));
    const maxScroll = rail.scrollWidth - rail.clientWidth;
    const maxTravel = Math.max(0, trackWidth - thumbWidth);
    const offset = maxScroll > 0 ? (rail.scrollLeft / maxScroll) * maxTravel : 0;

    thumb.style.width = `${thumbWidth}px`;
    thumb.style.transform = `translate3d(${offset}px, 0, 0)`;
  };

  const initRail = (rail) => {
    if (rail.dataset.overflowObserverReady === 'true') {
      updateRail(rail);
      return;
    }

    rail.dataset.overflowObserverReady = 'true';
    updateRail(rail);
    rail.addEventListener('scroll', () => updateRail(rail), { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => updateRail(rail));
      observer.observe(rail);
      const productGrid = rail.querySelector('.home_featured_products .grid');
      if (productGrid) observer.observe(productGrid);
    }

    rail.querySelectorAll('img').forEach((image) => {
      if (!image.complete) image.addEventListener('load', () => updateRail(rail), { once: true });
    });
  };

  const init = (root = document) => root.querySelectorAll(selector).forEach(initRail);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
